import * as Icons from './icons';

const Icon = ({ name, size = 24, color = 'currentColor', ...props }) => {
  const SvgIcon = Icons[name];

  if (!SvgIcon) {
    return null;
  }

  return <SvgIcon width={size} height={size} style={{ color }} {...props} />;
};

export default Icon;
